// extracted by mini-css-extract-plugin
export default {"content":"QK-z","lookName":"RK-z","shopTheLookContainer":"SK-z","productContainer":"TK-z","imageContainer":"UK-z","mainImage":"VK-z"};